<div class="table">

  <div class="table-body" *ngIf="!data || data.length == 0">
    <div class="table-row table-row-none">
      <div class="table-cell">
        <p>{{ noTableItemsText | anessaTranslation: trigger }}</p>
      </div>
    </div>
  </div>

  <div id="table-body"
       *ngIf="data && data.length > 0"
       [ngClass]="{'multiColumn': multiColumn}">
    <div class="table-row"
         [ngClass]="{'in-edit-mode': (editType == 'under-row' && editIndex == i),
                     'white-background': (style.includes('apply-fade'))}"
        *ngFor="let dataset of data; let i = index"
        [ngStyle]="{'background-color': (getRowsStripped() && i%2!==0) ? 'rgba(242, 242, 242, 0.8)' : ''}">

      <div class="row-content"
           [ngClass]="style"
           *ngIf="!(editType == 'in-place' && editIndex==i)">


        <ng-container *ngFor="let key of keys; let j = index"
        >
          <!-- if there are any items with either of the two icon states we activate the icon elements -->
          @if (showIconsForDataset(dataset, key)) {
            @if (hasErrorAndWarning(dataset, key)) {
              <!-- alternate both -->
              @if (iconToggler) {
                <mat-icon class="error-icon">error</mat-icon>
              } @else {
                <mat-icon class="warning-icon">warning</mat-icon>
              }
            } @else if (showErrorIcon(dataset, key)) {
              <mat-icon class="error-icon">error</mat-icon>
            } @else if (showWarningIcon(dataset, key)) {
              <mat-icon class="warning-icon">warning</mat-icon>
            } @else if (showLoadingIcon(dataset, key)) {
              <mat-spinner [diameter]="20"></mat-spinner>
            }
            <!-- if there are any icons we show the hidden placeholder icons elements-->
          } @else if (iconsActive()) {
            <!-- This is a hidden placeholder icon to align the rest of the items when
            a warning or error icon is shown -->
            <mat-icon style="visibility: hidden"
                      class=""
            >warning</mat-icon>
          }


          <div class="table-cell item-overflow name-cell"
               [ngClass]="{'default': (style.includes('default')),
                         'small': (style.includes('small')),
                         'fade-white-right': (style.includes('apply-fade')),
                         'anessa-dark-blue': isHighlighted(i),
                         'flex-1': !disableFlex1}"
               [ngStyle]="{'text-align': cellAlign[j],
                         'border-left': getBorder(j)}"
               [style.cursor]="'pointer'"
               [id]="(translateKeys && isTranslateKey(key)) ? (getElement(dataset, key) | anessaTranslation: trigger) : (getElement(dataset, key))"
               (click)="onEditClick(i, false)"
               [innerHTML]="(translateKeys && isTranslateKey(key)) ? (getElement(dataset, key) | anessaTranslation: trigger) : (getElement(dataset, key))">
          </div>
        </ng-container>

        <div class="flex-container"
              [ngClass]="{'flex-1':!disableFlex1}"
              [ngStyle]="{'width': getParentWidth(), 'justify-content': 'flex-end'}">
          <ng-container *ngIf="!isCustomFieldsMultiColumn; else multiColumn">
            <div class="value-cell vertical-center"
               *ngIf="customFields && customFields.length > i && customFields[i]"
               [ngClass]="{'default': (style.includes('default')),
                        'small': (style.includes('small')),
                        'fade-white-right': (style.includes('apply-fade')),
                        'anessa-dark-blue': isHighlighted(i)}"
               [ngStyle]="{'text-align': getTextAlign(), 'padding-right': getPaddingRight()}"
               [style.cursor]="'pointer'"
               (click)="onEditClick(i, false)">
              <span [ngStyle]="{'font-size': customFieldsFontSize}"
                [innerHTML]="processCustomFieldItem(customFields[i])"></span>
            </div>
          </ng-container>
          <ng-template #multiColumn>
            <ng-container *ngFor="let customField of customFields; let k = index">
              <div class="value-cell vertical-center"
                *ngIf="customField && customField.length > i && customField[i]"
                [ngClass]="{'default': (style.includes('default')),
                          'small': (style.includes('small')),
                          'fade-white-right': (style.includes('apply-fade')),
                          'anessa-dark-blue': isHighlighted(i)}"
                [ngStyle]="{'text-align': getTextAlign(), 'width': getChildWidth(), 'padding-right': getPaddingRight()}"
                [style.cursor]="'pointer'"
                (click)="onEditClick(i, false)">
                <span [ngStyle]="{'font-size': customFieldsFontSize}"
                  [innerHTML]="processCustomFieldItem(customField[i])"></span>
              </div>
            </ng-container>
          </ng-template>
          <div class="button-cell">
            <div class="duplicate"
                 *ngIf="isDuplicateActive && (editType!='under-row' || editIndex != i)">
              <a (click)="onDuplicateClick(i)"
                 [ngClass]="{'duplicate' : disableDuplicate}"
              >{{'HELPER.TABLE.DUPLICATE' | anessaTranslation: trigger}}</a>
            </div>

            <div class="additional"
                 *ngIf="isAdditionalActive && (editType!='under-row' || editIndex != i)">
              <a (click)="onAdditionalClick(i)"
              >{{ additionalBtnLinkText | anessaTranslation: trigger }}</a>
            </div>
            <div class="edit"
                 *ngIf="isEditActive && (editType!='under-row' || editIndex != i) && !editTextAltFunc">
              <a (click)="onEditClick(i, false)"
                 [ngClass]="{'disabled' : disableEdit,
                             'anessa-dark-blue': isHighlighted(i)}"
              >{{'HELPER.TABLE.EDIT' | anessaTranslation: trigger}}</a>
            </div>
            <div class="edit"
                 *ngIf="isEditActive && (editType!='under-row' || editIndex != i) && editTextAltFunc">
              <a (click)="onEditTextClick(i, false)"
                 [ngClass]="{'disabled' : disableEdit}"
              >{{'HELPER.TABLE.EDIT' | anessaTranslation: trigger}}</a>
            </div>

            <div class="remove"
                 (mouseleave)="removeIndex = -1"
                 *ngIf="isRemoveActive && (editType!='under-row' || editIndex != i)">
              <a (click)="onRemoveClick(i)"
                 [ngClass]="{'disabled' : disableRemove,
                             'anessa-dark-blue': isHighlighted(i)}"
              >{{'HELPER.TABLE.REMOVE' | anessaTranslation: trigger}}</a>
              <div class="remove-tooltip"
                   *ngIf="removeIndex == i">
                <p>{{ removeTooltipText | anessaTranslation: trigger }}</p>
                <div class="tooltip-buttons">
                  <a class="mat-mdc-button btn-green pseudo-button"
                     mat-button
                     (click)="onRemoveConfirm(i)">{{ confirmText | anessaTranslation: trigger }}</a>
                  <a class="mat-mdc-button btn-red pseudo-button"
                     mat-button
                     (click)="onRemoveCancel()"
                  >{{'PROJECT.COMMON.NO' | anessaTranslation: trigger}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--edit in place content-->
      <div class="edit-row-in-place"
           *ngIf="editType=='in-place' && editIndex==i">
        <div class="table-cell"
             [ngClass]="style"
             *ngFor="let key of keys; let j = index">
          <mat-form-field>
            <input type="text"
                   matInput
                   [(ngModel)]="dataset[key]">
          </mat-form-field>
        </div>

        <div class="button-cell">
          <div class="save">
            <a (click)="onSaveClick()">
              {{'PROJECT.COMMON.SAVE' | anessaTranslation: trigger}}
            </a>
          </div>
          <div class="cancel">
            <a (click)="onCancelClick(i)">
              {{'PROJECT.COMMON.CANCEL' | anessaTranslation: trigger}}
            </a>
          </div>
        </div>
      </div>

      <div class="edit-row"
           *ngIf="editType=='under-row' && editIndex == i">
        <ng-content id="under-row-content"
                    select=".under-row-content"></ng-content>
      </div>
    </div>
  </div>
</div>
